/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import PropTypes from 'prop-types';
import React from 'react';
import { Restart } from '@carbon/react/icons';
import { Button } from '@carbon/react';
import { useTranslation } from '../../../../Utilities/i18n/i18n.js';
import { noopFn } from '../../../../Utilities/propHelpers/defaultProps.js';

var TableSettingsReset = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var defaultSettings = _ref.defaultSettings,
    handleMenuItemFocus = _ref.handleMenuItemFocus,
    _ref$onClick = _ref.onClick,
    onClickProp = _ref$onClick === void 0 ? noopFn : _ref$onClick,
    _ref$closeMenu = _ref.closeMenu,
    closeMenu = _ref$closeMenu === void 0 ? noopFn : _ref$closeMenu;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var onClick = function onClick() {
    onClickProp(defaultSettings);
    closeMenu();
  };
  return /*#__PURE__*/React.createElement(Button, {
    ref: ref,
    "data-table-settings-item-focusable": true,
    renderIcon: Restart,
    iconDescription: t('Reset to default'),
    disabled: false,
    onClick: onClick,
    onKeyDown: handleMenuItemFocus
  }, t('Reset to default'));
});
var createDefaultSettingsPropType = function createDefaultSettingsPropType() {
  return function (props, propName, componentName) {
    var prop = props[propName]; // eslint-disable-line react/destructuring-assignment

    if (prop) {
      if (prop.defaultSize || prop.defaultCols) {
        return null;
      }
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ".  It must contain at least one of: defaultSize, defaultCols"));
    }
    return new Error("Required prop ".concat(propName, " is missing."));
  };
};
var defaultSettingsPropType = {};
defaultSettingsPropType.isRequired = createDefaultSettingsPropType();
TableSettingsReset.propTypes = {
  /**
   * Provide default settings to reset to
   */
  defaultSettings: defaultSettingsPropType.isRequired,
  /**
   * Provide an optional hook that is called each time the selection is updated
   */
  onClick: PropTypes.func,
  /**
   * Provide an optional hook to close menu that is called each time the reset button is clicked
   */
  closeMenu: PropTypes.func,
  /**
   * Provide an optional hook that is called each time a key is pressed
   */
  handleMenuItemFocus: PropTypes.func
};
var TableSettingsReset$1 = TableSettingsReset;

export { TableSettingsReset$1 as default };
